export const capitalize = (str, lowerCaseRest = false) => {
    if (!str?.length) return str;
    const lowerStr = lowerCaseRest ? str.toLowerCase() : str;
    return lowerStr
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join("");
    // return lowerStr.charAt(0).toUpperCase() + lowerStr.slice(1);
};
